import { AsyncComponentRender } from '@components/AsyncComponent';
import { createTabs } from '@packages/tabs';

export const TABS = createTabs([
    ['models', 'Models', AsyncComponentRender(() => import('./Models'))],
    ['textures', 'Textures', AsyncComponentRender(() => import('./Textures'))],
    ['gradients', 'Gradients', AsyncComponentRender(() => import('./Gradients'))],
    ['locations', 'Locations', AsyncComponentRender(() => import('./Locations'))],
    ['item-part', 'Item Parts', AsyncComponentRender(() => import('./ItemParts'))],
    ['graphics', 'Graphics', AsyncComponentRender(() => import('./Graphics'))],
    ['categories', 'Categories', AsyncComponentRender(() => import('./Categories'))],
]);
